import styled from 'styled-components';
import { SPACING_POINTS } from '@govuk-react/constants';
import { visuallyHidden, link, typography } from '@govuk-react/lib';

/**
 * ### References
 *
 * - https://github.com/alphagov/govuk-frontend/tree/main/src/govuk/components/skip-link
 */
/**
 *
 * Use the skip link component to help keyboard-only users skip to the main content on a page.
 *
 * - https://govuk-react.github.io/govuk-react/?path=/docs/skip-link
 * - https://design-system.service.gov.uk/components/skip-link/
 */

var SkipLink = styled('a').withConfig({
  displayName: "src__SkipLink",
  componentId: "sc-njuwuz-0"
})(visuallyHidden.focusable(), link.common(), link.styleText, typography.responsive(16), {
  display: 'block',
  padding: "".concat(SPACING_POINTS[2], "px ").concat(SPACING_POINTS[3], "px"),
  '@supports (padding:max(calc(0px)))': {
    paddingRight: "max(".concat(SPACING_POINTS[3], "px, calc(").concat(SPACING_POINTS[3], "px + env(safe-area-inset-right)))"),
    paddingLeft: "max(".concat(SPACING_POINTS[3], "px, calc(").concat(SPACING_POINTS[3], "px + env(safe-area-inset-left)))")
  }
});
SkipLink.defaultProps = {
  children: 'Skip to main content',
  href: '#content'
};
SkipLink.displayName = 'SkipLink';

export { SkipLink, SkipLink as default };
